/*
 * @Descripttion: 深蓝风格
 * @Author: shenah
 * @Date: 2023-07-17 16:51:35
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-07-24 17:32:13
 */

export default {
  name: "深蓝风格",
  value: "blueStyle",
  picture: "dd0627d15353426c95140d84df82e108",
  style: {
    //页面
    dataviewPage: {
      //字体颜色
      fontColor: "rgb(245,252,255)",
      //页面背景
      backgroundConfig: {
        active: "pattern",
        pattern: {
          image: "3b936957be584273894e32c89d5381d5",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
    },
    // 选中与未选中的样式
    dataViewSelectStyle: {
      defaultColor: "#fff",
      clickColor: "rgb(165, 201, 255)",
    },
    //面板标题
    dataviewPanelText: {
      backgroundConfig: {
        active: "pattern",
        pattern: {
          image: "062ee2eb62b64134bd4ccf28bb8e91b4",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "rgb(255, 255, 255)",
      subTitleColor: "rgb(255, 255, 255)",
    },
    //面板组件
    dataviewPanel: {
      //标题背景
      titleBackgroundConfig: {
        active: "pattern",
        pattern: {
          image: "062ee2eb62b64134bd4ccf28bb8e91b4",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "rgb(255, 255, 255)",
      //子标题
      subTitleColor: "rgb(255, 255, 255)",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //头部横栏
    dataviewHeaderContent: {
      //标题背景
      titleBackgroundConfig: {
        active: "pattern",
        pattern: {
          image: "f53dcba756ca4d7a93b17e21960f4a9c",
          size: "100% 100%",
          repeat: "no-repeat",
          position: "center",
        },
      },
      //标题颜色
      titleColor: "rgb(255, 255, 255)",
      //子标题
      subTitleColor: "rgb(255, 255, 255)",
      //边框颜色
      borderColor: "#FFDC4C",
    },
    //表格组件
    dataviewTable: {
      barColors: ["rgb(165, 201, 255)"], // 柱体的背景色
      prop_headerBGC: "", // 统一的表头背景色
      prop_headerColor: "rgb(201, 233, 255)", // 统一的表头颜色
      contentColor: "rgb(165, 201, 255)", // 统一的内容颜色
    },
    //图表组件
    dataviewGraph: {
      // 标题
      title: {
        labelColor: "rgb(245,252,255)",
      },
      // 图例
      legend: {
        labelColor: "rgb(245,252,255)",
      },
      // 坐标系颜色控制
      axis: {
        labelColor: "rgba(221, 229, 237, 1)",
        lineColor: "rgba(17, 28, 48, 0.2)",
      },
      // 地图颜色设置
      map: {
        colors: ["#2239DE"], // 地图区域颜色
        labelColor: "#fff", // 地图文字颜色
        borderColor: "rgba(50, 89, 122,1)", // 地图边线文字
      },
      // 图形颜色设置
      commonStyle: {
        colors: [
          ["rgba(1,119,254,0.2)", "rgba(1,119,254,0.6)", "rgba(1,119,254,1)"],
          [
            "rgba(123,121,252,0.2)",
            "rgba(123,121,252,0.6)",
            "rgba(123,121,252,1)",
          ],
          [
            "rgba(65,175,107,0.2)",
            "rgba(65,175,107,0.6)",
            "rgba(65,175,107,1)",
          ],
          [
            "rgba(98,217,173,0.2)",
            "rgba(98,217,173,0.6)",
            "rgba(98,217,173,1)",
          ],
          [
            "rgba(255,220,76,0.2)",
            "rgba(255,220,76,0.6)",
            "rgba(255,220,76,1)",
          ],
          [
            "rgba(168,223,250,0.2)",
            "rgba(168,223,250,0.6)",
            "rgba(168,223,250,1)",
          ],
        ],
        barColors: [
          ["rgba(0,191,255,0.2)", "rgba(0,191,255,0.6)", "rgba(0,191,255,1)"],
          [
            "rgba(98,217,173,0.2)",
            "rgba(98,217,173,0.6)",
            "rgba(98,217,173,1)",
          ],
          [
            "rgba(255,220,76,0.2)",
            "rgba(255,220,76,0.6)",
            "rgba(255,220,76,1)",
          ],
          [
            "rgba(168,223,250,0.2)",
            "rgba(168,223,250,0.6)",
            "rgba(168,223,250,1)",
          ],
          [
            "rgba(115,192,222,0.2)",
            "rgba(115,192,222,0.6)",
            "rgba(115,192,222,1)",
          ],
          [
            "rgba(52,162,114,0.2)",
            "rgba(52,162,114,0.6)",
            "rgba(52,162,114,1)",
          ],
          [
            "rgba(91,110,150,0.2)",
            "rgba(91,110,150,0.6)",
            "rgba(91,110,150,1)",
          ],
        ],
        labelColor: "rgb(245,252,255)",
      },
    },
    //图文组件
    dataviewKeyTrades: {
      backgroundConfigs: [], // 单个背景(里面对象则为背景的通用对象)
      attachObj: {
        // 统一
        nameColor: "rgb(201, 233, 255)", // 名称颜色
        valueColor: "rgb(165, 201, 255)", // 值颜色
        unitColor: "rgb(165, 201, 255)", // 单位颜色
      },
    },
  },
};
